import React, { FC } from 'react';
import Legal from '../Legal';
import SocialLinks from '../SocialLinks';
import CurrencySelectorInput from '../CurrencySelectorInput';
import FooterLanguageSelector from '../Footer/FooterLanguageSelector';
import styles from './SubFooter.module.scss';

const SubFooter: FC = () => (
  <div className={styles.root}>
    <Legal />
    <div className={styles.selectors}>
      <CurrencySelectorInput id="currency-footer" variant="withFlag" />
      <FooterLanguageSelector classNameModifier="subFooter" />
    </div>
    <SocialLinks />
  </div>
);

export default SubFooter;
